import Vue from 'vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { faSpinner } from '@fortawesome/free-solid-svg-icons/faSpinner'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons/faPlusCircle'
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons/faMinusCircle'
import { faEdit } from '@fortawesome/free-solid-svg-icons/faEdit'
import { faTrash } from '@fortawesome/free-solid-svg-icons/faTrash'
import { faCartPlus } from '@fortawesome/free-solid-svg-icons/faCartPlus'
import { faHeart } from '@fortawesome/free-solid-svg-icons/faHeart'
import { faCheck } from '@fortawesome/free-solid-svg-icons/faCheck'
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes'
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome'
import { faUtensils } from '@fortawesome/free-solid-svg-icons/faUtensils'
import { faShoppingCart } from '@fortawesome/free-solid-svg-icons/faShoppingCart'
import { faShoppingBag } from '@fortawesome/free-solid-svg-icons/faShoppingBag'
import { faCalendarAlt } from '@fortawesome/free-regular-svg-icons/faCalendarAlt'
import { faHistory } from '@fortawesome/free-solid-svg-icons/faHistory'
import { faLanguage } from '@fortawesome/free-solid-svg-icons/faLanguage'
import { faImage } from '@fortawesome/free-regular-svg-icons/faImage'

Vue.component('font-awesome-icon', FontAwesomeIcon)

library.add(
  faSpinner,
  faPlusCircle,
  faMinusCircle,
  faEdit,
  faTrash,
  faCartPlus,
  faHeart,
  faCheck,
  faTimes,
  faHome,
  faUtensils,
  faShoppingCart,
  faShoppingBag,
  faCalendarAlt,
  faHistory,
  faLanguage,
  faImage
)
